import {
  MixtureCandidateDetailDto,
  MixtureCandidateDto
} from 'src/store/mixturecandidates/mixturecandidate';
import { ArrayUtils } from 'src/utils/array';
import {
  MixtureCandidateAction,
  MixtureCandidateTypes
} from './mixturecandidates.actions';

export type MixtureCandidatesState = Readonly<{
  mixtureCandidates: MixtureCandidateDto[];
  mixtureCandidate: Nullable<MixtureCandidateDetailDto>;
  errors: any;
}>;

const initialState: MixtureCandidatesState = {
  mixtureCandidates: [],
  mixtureCandidate: null,
  errors: null
};

const mixtureCandidatesReducer = (
  state: MixtureCandidatesState = initialState,
  action: MixtureCandidateAction
) => {
  switch (action.type) {
    case MixtureCandidateTypes.Fetch:
      return { ...state, mixtureCandidate: action.mixtureCandidate };
    case MixtureCandidateTypes.FetchAll:
      return { ...state, mixtureCandidates: action.mixtureCandidates };
    case MixtureCandidateTypes.Add:
      return {
        ...state,
        mixtureCandidates: [...state.mixtureCandidates, action.mixtureCandidate]
      };
    case MixtureCandidateTypes.Update:
      return {
        ...state,
        mixtureCandidates: ArrayUtils.updateListById(
          state.mixtureCandidates,
          action.mixtureCandidate
        )
      };
    case MixtureCandidateTypes.Delete:
      return {
        ...state,
        mixtureCandidate: null,
        mixtureCandidates: ArrayUtils.deleteFromListById(
          state.mixtureCandidates,
          action.mixtureCandidate
        )
      };
    case MixtureCandidateTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default mixtureCandidatesReducer;
